import _ from "lodash";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import Iframe from "react-iframe";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;

class TemplatePreview extends Component {
  constructor(props) {
    super(props);
    var websiteurl = `https://eventify.io/previews/${props.templateObj.modulepath}/index.php?eventcode=${props.eventcode}`;

    this.state = {
      loading: false,
      websiteurl,
    };
  }

  componentDidMount = () => {};

  closePreview = (e) => {
    this.props.closePreview();
  };

  renderLoader = () => {
    return (
      <Loader
        type="line-scale-pulse-out-rapid"
        active
        className="template-loader-div"
      />
    );
  };

  render() {
    let { templateImagepath, session } = this.props;


    let imgurl = "";
    if (templateImagepath && !_.isEmpty(templateImagepath)) {
      //Old codes -> imgurl = `http://devapi.eventify.io/api/v2/files/${templateImagepath.resource[0].template_imglarge}?api_key=${state.session.apiKey}`;
      imgurl = `http://devapi.eventify.io/api/v2/files/${templateImagepath.resource[0].template_imglarge}?api_key=${session.apiKey}`;
    }

    return (
      <div>
        <Modal
          show={this.props.openTemplateModel}
          onHide={this.closePreview}
          dialogClassName="templatePreview"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.website_theme_text_template_preview}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closePreview()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* <div className="import-header">
                            <div className="import-modal-title">{LocaleStrings.website_theme_text_template_preview}</div>
                            <button type="button" className="close btn-sm btn-close " onClick={() => this.closePreview()} style={{marginTop:-25}}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div> */}

            {/* <div className="template-preview-container">
                            <Iframe url={this.state.websiteurl}
                                width="100%"
                                height="100%"
                                id="webbrowser"
                                display="initial"
                                position="relative"/>
                        </div> */}

            {this.props.templateImagepath &&
            this.props.templateImagepath.resource &&
            this.props.templateImagepath.resource.length > 0 ? (
              <div className="template-preview-container">
                <img src={imgurl} />
              </div>
            ) : (
              <div className="template-preview-container">
                <div className="col-md-12 text-center">
                  {this.renderLoader()}
                  <div className="loader-info">{"Loading..."}</div>
                </div>
              </div>
            )}
          </Modal.Body>
          {/* <Modal.Footer>
                        <Button className="button-theme button-theme-blue" onClick={this.closePreview}>Close</Button>
                    </Modal.Footer> */}
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={this.closePreview}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventcode: state.eventcode,

    templateImagepath: state.templateImagepath,
  };
}

export default connect(mapStateToProps)(TemplatePreview);
